<!--suppress ALL -->
<template>
  <div>
    <div class="row">
      <div class="col-8">
        <form>
          <div v-for="phoenix_setting in filtered_phoenix_settings" :key="phoenix_setting.phoenix_setting_id">
            <b v-if="phoenix_setting.setting === 'SCHOOL_SIP_INCOMING_IVR.CONDITION'">school_SIP_incoming_IVR</b>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_INCOMING_IVR.CONDITION'">
              <label for="txtIVRCondition" class="col-4 col-form-label">Condition</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtIVRCondition"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_INCOMING_IVR.TRANSFER_DATA'">
              <label for="txtIVRTransferData" class="col-4 col-form-label">Transfer Data</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtIVRTransferData"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <b v-if="phoenix_setting.setting === 'SCHOOL_SIP_INCOMING_ALL_CALL.CONDITION'">school_SIP_incoming_AllCall</b>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_INCOMING_ALL_CALL.CONDITION'">
              <label for="txtAllCallCondition" class="col-4 col-form-label">Condition</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtAllCallCondition"
                       v-model="phoenix_setting.value">
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'SCHOOL_SIP_INCOMING_ALL_CALL.TRANSFER_DATA'">
              <label for="txtAllCallTransferData" class="col-4 col-form-label">Transfer Data</label>
              <div class="col-8">
                <input type="text" class="form-control" id="txtAllCallTransferData"
                       v-model="phoenix_setting.value">
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Save</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      phoenix_settings: 'allPhoenixSettings',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_phoenix_settings: function () {
      return this.phoenix_settings.filter(ps => ps.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.INTERCOM.DIAL_PLAN.PUBLIC')
  },
  methods: {
    submit () {
      this.$store.dispatch('editPhoenixSettings', this.phoenix_settings)
    }
  }
}
</script>

<style scoped>

</style>
